import i from "./index.es84.js";
import s from "./index.es85.js";
import a from "./index.es58.js";
const l = function(e, t) {
  return i.map((o) => o.toLowerCase()).indexOf(e.toLowerCase()) >= 0 && (t = e), t;
};
function m(e) {
  return Object.keys(e).filter((t) => a(t)).reduce(
    (t, r) => {
      const o = r.toLowerCase(), n = s[o] || o;
      return t[n] = l(n, e[r]), t;
    },
    {}
  );
}
export {
  m as default
};
//# sourceMappingURL=index.es75.js.map
